import Backdrop from '@mui/material/Backdrop';
import { alpha, SxProps, Theme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { exportsDownloadingSelector } from '../state';
import { LoadingState } from './Visual';

const sx: SxProps<Theme> = {
  color: theme => theme.palette.primary.contrastText,
  zIndex: theme => theme.zIndex.drawer + 10,
  backdropFilter: 'blur(8px)',
  backgroundColor: theme => alpha(theme.palette.text.primary, 0.42),
};

const DownloadOverlay = () => {
  const loading = useSelector(exportsDownloadingSelector);
  const { t } = useTranslation();
  return (
    <Backdrop sx={sx} open={loading}>
      <LoadingState
        title={t('exports.loading.title')}
        description={t('exports.loading.description')}
      />
    </Backdrop>
  );
};

export default DownloadOverlay;
